module.exports = __webpack_public_path__ + "img/Banner-Test_A.a22680fc.webp";